module.exports = __webpack_public_path__ + "static/media/sellinghistoryActive.189f9a9b.svg";